<div class="manage-assessment"  style="padding-bottom: var(--footer-height, 56px); box-sizing: border-box;">
    <app-module-title moduleName="Manage Assessment"></app-module-title>

    <div class="action-tabs-container">
        <div class="custom-tabs">
            <!-- Dynamically render tabs based on visibleTabs array -->
            <div *ngFor="let tab of visibleTabs" class="custom-tab" [ngClass]="{ 'active': activeTab === tab.status }"
                [pTooltip]="tab.tooltip"
                tooltipPosition="bottom"
                tooltipStyleClass="custom-tooltip"
                (click)="navigateToTab(tab.status)">
                {{ tab.label }}
            </div>
        </div>
        <div class="action-buttons-container" *ngIf="currentUserRole !== UserRole.LocalRA && currentUserRole !== UserRole.LocalRA1">
            <!-- Action buttons for Upload and Create RCA -->
            <p-button label="Upload RCA" icon="pi pi-upload" [style]="{
              'background-color': 'var(--Gray, #424c4f)',
              color: 'white',
              border: 'none',
              'font-weight': '500'
            }" (onClick)="handleUploadRCA()">
            </p-button>
            <p-button label="Create RCA" icon="pi pi-plus" [style]="{
              'background-color': 'var(--Yellow, #F0D413)',
              color: 'black',
              border: 'none',
              'font-weight': '500'
            }" (onClick)="handleCreateRCA()">
            </p-button>
        </div>
    </div>

    <div class="tab-content-container">
        <app-manage-assessment-tab [activeTab]="activeTab" (resumeRca)="handleResumeRca($event)" (assessmentCountsUpdated)="onAssessmentCountsUpdated($event)"
            #assessmentTableComponent></app-manage-assessment-tab>
    </div>

    <!-- RCA Creation/Edit Form Dialog -->
    <div *ngIf="showNewRCADialog">
        <app-manage-assessment-form [visible]="showNewRCADialog" (closeDialog)="showNewRCADialog = false"
            (rcaCreated)="onRcaCreated($event)" [rcaDataToPatch]="rcaDataToPatch"
            (rcaPatched)="onRcaPatched()"></app-manage-assessment-form>
    </div>

    <!-- Success Popup -->
    <app-manage-assessment-success-popup *ngIf="successPopupVisible" [visible]="successPopupVisible" [data]="successPopupData"
        (closeDialog)="onSuccessPopupClose()"></app-manage-assessment-success-popup>

    <!-- RCA Upload Dialog -->
    <app-manage-assessment-upload-popup [visible]="showUploadRCADialog" (closeDialog)="showUploadRCADialog = false"
        (saveDraft)="onSaveRcaDraft()" (submitForm)="onSubmitRcaForm()"
        (uploadFile)="onRcaFileUpload($event)"></app-manage-assessment-upload-popup>

</div>